
export const prizeCatalog = ['', 'cine', 'kit', 'postal', 'receta', 'book'];
